// BlogPost.jsx
import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { POSTS } from "./BlogsPage"; // adjust path if POSTS lives elsewhere
import "../styles/BlogPost.css";

export default function BlogPost() {
  const { id } = useParams();
  const navigate = useNavigate();
  const post = POSTS.find((p) => p.id === id);

  if (!post) {
    return (
      <div style={{ padding: 40 }}>
        <h2>Post not found</h2>
        <button onClick={() => navigate("/blogs")}>Back to blogs</button>
      </div>
    );
  }

  return (
    <div className="bp-page">
      {/* hero area: dark, large */}
      <header
        className="bp-hero"
        style={{ backgroundImage: `url(${post.hero || "https://user-gen-media-assets.s3.amazonaws.com/gemini_images/f7773464-549e-4421-88f4-77c74b1124ba.png"})` }}
        aria-hidden="true"
      >
        <div className="bp-hero-vignette" />
      </header>

      {/* overlapping white card */}
      <main className="bp-main" role="main">
        <article className="bp-card" aria-labelledby="bp-title">
          <Link className="bp-back-top" to="/blogs">← Back</Link>

          <h1 id="bp-title" className="bp-title">{post.title}</h1>

          <p className="bp-subtitle">
            {post.excerpt}
          </p>

          <div className="bp-content">
            {String(post.content || "").split("\n\n").map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>

          <div className="bp-actions">
            <Link className="bp-back-bottom" to="/blogs">← Back</Link>
          </div>
        </article>
      </main>
    </div>
  );
}